import { MutationHandlingServiceV2 } from '@akebono/core';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { of } from 'rxjs';
import { finalize, shareReplay } from 'rxjs/operators';

import { AutoLotView } from '../../../../../const';
import {
  LotSource,
  LotTypeEnum,
  LotUpdateGQL,
} from '../../../../graphql/service/graphql-auto-main-service';

@Component({
  selector: 'app-lot-edit-start-price',
  templateUrl: './lot-edit-start-price.component.html',
  styleUrls: ['./lot-edit-start-price.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LotEditStartPriceComponent implements OnInit {
  @Input() lot: AutoLotView;
  @Input() lotType: LotTypeEnum;
  @Input() lotSource: LotSource;
  @Output() actionComplete = new EventEmitter<void>();

  showPopover = false;
  startPriceValue = 0;
  saving = of(false);

  constructor(private mhs: MutationHandlingServiceV2, private lotUpdateGQL: LotUpdateGQL) {}

  ngOnInit(): void {
    this.startPriceValue = this.lot.startPrice ?? 0;
  }

  saveStartPrice(): void {
    this.saving = this.mhs
      .mutate(this.lotUpdateGQL, {
        input: {
          lotId: this.lot.id,
          lotType: this.lotType,
          lotSource: this.lotSource,
          startPriceNum: this.startPriceValue,
        },
      })
      .loading.pipe(
        finalize(() => {
          this.actionComplete.emit();
          this.showPopover = false;
        }),
        shareReplay(),
      );
  }
}
